import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";

const HouseholdAssessmentDetail = ({ householdAssessmentDetails }) => {
  const houseHoldAssessmentColumns = [
    {
      field: "householdAssessmentId",
      headerName: "Household Assessment ID",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "internalapplicationid",
      headerName: "Internal Application ID",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "requestedloanamount",
      headerName: "Requested Loan Amount",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "recommendedloanamount",
      headerName: "Recommended Loan Amount",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "tenure",
      headerName: "Tenure",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "interest",
      headerName: "Interest",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "ltv",
      headerName: "LTV",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "assessedrole",
      headerName: "Assessed Role",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
  ];

  return (
    <>
      <AccordianContainer
        id="accord"
        title="Household Assessment Details"
        initialOpen={false}
      >
        <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={
              householdAssessmentDetails !== undefined &&
              householdAssessmentDetails !== null
                ? householdAssessmentDetails.map((item, index) => ({
                    id: index + 1,
                    ...item,
                  }))
                : []
            }
            columns={houseHoldAssessmentColumns}
            pageSize={15}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.householdAssessmentId}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
        </Box>
      </AccordianContainer>
    </>
  );
};

export default HouseholdAssessmentDetail;
